export const dentalOfficeRightFields = [
  {
    name: 'hasSalesAssistant',
    label: 'Présence assistant(e)s commercial(e)s :',
    type: 'switch'
  },
  {
    name: 'hasSecretarialAssistant',
    label: 'Présence assistant(e)s secrétariat :',
    type: 'switch'
  },
  {
    name: 'hasEmployedProsthetist',
    label: 'Présence de prothésistes salariés :',
    type: 'switch'
  },
  {
    name: 'chairCount',
    label: 'Nombre de fauteuils :',
    placeholder: 'Ex : 3',
    type: 'number',
    required: true
  },
  {
    name: 'radioTypes',
    label: 'Type de radio-panoramiques :',
    type: 'checkbox-group',
    options: [
      {name: 'hasRadio2d', label: '2D'},
      {name: 'hasRadio3d', label: '3D'}
    ]
  }
];
